module.exports = __webpack_public_path__ + "img/ad6.3a60bedd.jpg";